import moment from 'moment';

export const MIN_DATE = moment(`1000-01`, 'yyyy-MM');
export const MAX_DATE = moment(`9000-12`, 'yyyy-MM');
